import { render } from "./StackedImages.vue?vue&type=template&id=c1172624&scoped=true"
import script from "./StackedImages.vue?vue&type=script&lang=js"
export * from "./StackedImages.vue?vue&type=script&lang=js"

import "./StackedImages.vue?vue&type=style&index=0&id=c1172624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1172624"]])

export default __exports__